module.exports = __webpack_public_path__ + "assets/img/star_score_s.e58b4c82.png";